import React from 'react';
import { STOP_STATE_VISUAL, STOP_DISPLAY_STATES } from '../../util/routeStopState';

// Numbered route pin with state-coded color + small icon badge.
//
// Usage:
//   Inline (list mode):
//     <StopMarker sequence={2} displayState="in_progress" />
//
//   Map (Google Maps AdvancedMarkerElement content):
//     const el = document.createElement('div');
//     ReactDOM.render(<StopMarker sequence={2} displayState="up_next" active />, el);
//     new google.maps.marker.AdvancedMarkerElement({ position, map, content: el });
//
// Props:
//   sequence    — 1-indexed integer from stop.sequence (server field)
//   displayState — 'up_next' | 'in_travel' | 'arrived' | 'in_progress' | 'completed'
//   active       — boolean, when true the marker enlarges + pulses (for the
//                  currently-active stop)
//   size         — 'sm' | 'md' (default) | 'lg'

const SIZE_PX = { sm: 28, md: 36, lg: 48 };

const StopMarker = ({ sequence, displayState = STOP_DISPLAY_STATES.UP_NEXT, active = false, size = 'md' }) => {
  const visual = STOP_STATE_VISUAL[displayState] || STOP_STATE_VISUAL.up_next;
  const px = SIZE_PX[size] || SIZE_PX.md;
  const isCompleted = displayState === STOP_DISPLAY_STATES.COMPLETED;
  const isActive = active || displayState === STOP_DISPLAY_STATES.IN_PROGRESS;

  return (
    <div
      className={`stop-marker stop-marker--${displayState}${isActive ? ' stop-marker--active' : ''}`}
      style={{
        width: px,
        height: px,
        borderRadius: '50%',
        background: '#ffffff',
        border: `3px solid ${visual.color}`,
        color: visual.color,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: Math.round(px * 0.4),
        position: 'relative',
        boxShadow: isActive ? `0 0 0 4px ${visual.color}33` : '0 1px 2px rgba(0,0,0,0.15)',
        transition: 'box-shadow 200ms ease',
      }}
      aria-label={`Stop ${sequence}, ${visual.label}`}
      title={`Stop ${sequence} · ${visual.label}`}
    >
      {isCompleted ? <i className={visual.icon} aria-hidden="true" /> : sequence}
      <span
        className="stop-marker__state-badge"
        style={{
          position: 'absolute',
          bottom: -4,
          right: -4,
          width: Math.round(px * 0.45),
          height: Math.round(px * 0.45),
          borderRadius: '50%',
          background: visual.color,
          color: '#ffffff',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: Math.round(px * 0.22),
          border: '2px solid #ffffff',
        }}
      >
        <i className={visual.icon} aria-hidden="true" />
      </span>
    </div>
  );
};

export default StopMarker;
